export default {
  displayName: 'NGX Calculator',
  allowableParents: ['Section'],
};
